import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../ThemeContext';

export default function ThemeToggle() {
  const { isDark, t, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Light mode' : 'Dark mode'}
      style={{
        position: 'fixed',
        bottom: '24px',
        right: '24px',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        background: t.surfaceElevated,
        border: `1px solid ${t.borderStrong}`,
        borderRadius: '999px',
        padding: '4px',
        cursor: 'pointer',
        width: '52px',
        height: '28px',
        transition: 'background-color 0.3s, border-color 0.3s',
        boxShadow: isDark ? 'none' : '0 2px 8px rgba(0,0,0,0.1)',
      }}
      onMouseEnter={(e) => e.currentTarget.style.borderColor = t.accent}
      onMouseLeave={(e) => e.currentTarget.style.borderColor = t.borderStrong}
    >
      {/* Thumb */}
      <div style={{
        width: '20px',
        height: '20px',
        borderRadius: '50%',
        backgroundColor: t.accent,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transform: isDark ? 'translateX(0)' : 'translateX(24px)',
        transition: 'transform 0.2s cubic-bezier(0.16, 1, 0.3, 1)',
      }}>
        {isDark ? (
          <Moon size={11} color={t.bg} strokeWidth={2.5} />
        ) : (
          <Sun size={11} color={t.buttonText} strokeWidth={2.5} />
        )}
      </div>
    </button>
  );
}
